import { Component, Input, OnDestroy } from '@angular/core';
import {
    AppNotificationService,
    AppNotificationType,
    EquipmentModel,
    FormattedServiceKey,
    ModalClass,
    ODataModel,
    SoftwareLicenceModel,
    TableModel,
} from '@evorait/pace-core';
import * as _ from 'lodash';
import EquipmentConfigurationModel from '../equipment-configuration.model';
import { TranslateService } from '@ngx-translate/core';
import { faChevronDown, faChevronUp, faKey } from '@fortawesome/free-solid-svg-icons';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subscription } from 'rxjs';
import { EquipmentConfigurationServiceKeyComponent } from '../../equipment-configuration-service-key/equipment-configuration-service-key.component';
import { EquipmentConfigurationServiceKeyModel } from '../../equipment-configuration-service-key/equipment-configuration-service-key.model';

@Component({
    selector: 'pace-equipment-configuration-detail',
    templateUrl: './equipment-configuration-detail.component.html',
    styleUrls: ['./equipment-configuration-detail.component.scss'],
    standalone: false,
})
export class EquipmentConfigurationDetailComponent implements OnDestroy {
    @Input()
    public equipConfigModel: EquipmentConfigurationModel;

    @Input()
    public tableModel: TableModel<ODataModel>;

    @Input()
    public rowData: EquipmentModel;

    @Input()
    public softwareLicencesDisplayed = false;

    @Input()
    public softwareLicences: Observable<TableModel<SoftwareLicenceModel>>;

    @Input()
    public technicalIdOrFunctionalLocationLabel = '';

    @Input() public displayMaparField = false;
    @Input() public displayContractField = false;

    public faKey = faKey;
    private serviceKeyHandler?: Subscription;
    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    public constructor(
        private readonly translate: TranslateService,
        private readonly modalService: BsModalService,
        private readonly appNotificationService: AppNotificationService,
    ) {}

    public ngOnDestroy(): void {
        if (typeof this.serviceKeyHandler !== 'undefined') {
            this.serviceKeyHandler.unsubscribe();
        }
    }

    public formatServiceKey(serviceKey: string): FormattedServiceKey {
        return EquipmentModel.returnFormattedServiceKey(serviceKey);
    }

    public showServiceKey(): void {
        const serviceKey = EquipmentModel.returnFormattedServiceKey(
            this.equipConfigModel.tableModel.selectedRow.serviceKey.value,
        );
        const formattedServiceKey = `${serviceKey.primaryText}<strong>${serviceKey.emphasizedText}</strong>`;
        this.appNotificationService.setAppNotification(
            AppNotificationType.INFO,
            <string>this.translate.instant('NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_SERVICE_KEY'),
            formattedServiceKey,
        );
    }

    public get<T>(row: ODataModel, field: string): T {
        return _.get(row, field);
    }

    public openServiceKey(): void {
        const modalInstance = this.modalService.show(EquipmentConfigurationServiceKeyComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            initialState: {
                model: new EquipmentConfigurationServiceKeyModel(
                    this.rowData,
                    this.equipConfigModel.qmNum,
                    this.equipConfigModel.process,
                ),
            },
            ariaLabelledBy: 'equipment-configuration-service-key-modal-title',
        });

        this.serviceKeyHandler = modalInstance.content?.serviceKeySetChanged.subscribe(() =>
            this.equipConfigModel.updateServiceKeyValue(),
        );
    }
}
